export default class AdfHeaderSearch
{
    constructor ()
    {

        this.headerSearchSection  = document.querySelector( '#nav-search-section' );
        this.btnToggleSearch      = this.headerSearchSection.querySelector( '#nav-search-mobile-toggle' );
        this.mobileInputContainer = this.headerSearchSection.querySelector( '.input-inner' );

        //this.bindEvents();


    }

    bindEvents ()
    {
        if (this.btnToggleSearch)
        this.btnToggleSearch.addEventListener( 'click', this.toggleMobileSearch.bind( this ) );

    }

    toggleMobileSearch ()
    {

        if ( this.mobileInputContainer.classList.contains( 'open' ) )
        {
            this.closeMobileSearch();
        }
        else
        {
            this.openMobileSearch();
        }
    }

    openMobileSearch ()
    {
        this.mobileInputContainer.classList.add( 'open' );

        this.btnToggleSearch.classList.add( 'open' );
    }

    closeMobileSearch ()
    {
        this.mobileInputContainer.classList.remove( 'open' );

        this.btnToggleSearch.classList.remove( 'open' );
    }



}

